import React from 'react';
import { motion } from 'framer-motion';

interface MenuToggleProps {
  isComboMode: boolean;
  onToggle: (isComboMode: boolean) => void;
  comboCount: number;
  className?: string;
}

const MenuToggle: React.FC<MenuToggleProps> = ({
  isComboMode,
  onToggle,
  comboCount,
  className = ''
}) => {
  return (
    <div className={`flex items-center justify-end mb-6 ${className}`}>
      <div className="flex items-center space-x-3">
        <span className="text-sm font-medium text-gray-700">
          Combos ({comboCount})
        </span>
        <button
          onClick={() => onToggle(!isComboMode)}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 focus:outline-none ${
            isComboMode ? 'bg-red-500' : 'bg-gray-200'
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-lg transition-transform duration-200 ${
              isComboMode ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
      </div>
    </div>
  );
};

export default MenuToggle;
